import React, { useCallback as useCallbackDI } from 'react';
import { HelpPanelLink as HelpPanelLinkDI } from '@atlassian/jira-help-panel-button/src/index.tsx';
import {
	fireUIAnalytics as fireUIAnalyticsDI,
	useAnalyticsEvents as useAnalyticsEventsDI,
} from '@atlassian/jira-product-analytics-bridge';
import type { HelpPanelButtonProps } from './types.tsx';

export const HelpPanelButton = ({
	HelpButtonLink = HelpPanelLinkDI,
	articleId,
	fireUIAnalytics = fireUIAnalyticsDI,
	useAnalyticsEvents = useAnalyticsEventsDI,
	useCallback = useCallbackDI,
	...rest
}: HelpPanelButtonProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const onClick = useCallback(
		() =>
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'navigationItem',
				}),
				'sidebar',
				{
					helpArticleId: articleId,
					itemId: 'learnMore',
				},
			),
		[articleId, createAnalyticsEvent, fireUIAnalytics],
	);

	return (
		<HelpButtonLink
			articleId={articleId}
			type="HELP_ARTICLE"
			appearance="subtle-link"
			spacing="none"
			onClick={onClick}
			{...rest}
		/>
	);
};
